import React, { useEffect, useState } from 'react'
import { postDQListButtonPreoperatorio, postInsertPreoperatorio } from '../../../services/PaginaRuta'
import TablaDiagnosticoDescripcionQxPostOperatorio from './TablaDiagnosticoDescripcionQxPostOperatorio'
import ModalListaDeSeleccionDeDiagnosticoPostOperatorio from './ModalListaDeSeleccionDeDiagnosticoPostOperatorio'

const ModalDiagnosticosDescripcionPostOperatorio = ({setmodalOnDiagnosticoDescripcionPostOperatorio,procir,codigoMedico}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataPostOperatorio, setdataPostOperatorio]=useState([])
  const [observacionesPostOperatorio, setobservacionesPostOperatorio]=useState('')
  const [actualizarTable, setactualizarTable]=useState([])
  const [passDataGuardarPostOperatorio, setpassDataGuardarPostOperatorio]=useState({
    CodDxPrPo: '',
    DMNomb: ''
  })
  const [modalOnListaDeSeleccionDiagnosticoPostOperatorio, setmodalOnListaDeSeleccionDiagnosticoPostOperatorio]=useState(false)
  const handleCancelarClick=()=>{
        setmodalOnDiagnosticoDescripcionPostOperatorio(false)
    }
    const handleOnclickSeleccionDianostico=()=>{
      setmodalOnListaDeSeleccionDiagnosticoPostOperatorio(true)
    }
    const passDataPostOperatorio=(data)=>{
      setpassDataGuardarPostOperatorio(data)
    }
    useEffect(()=>{
      const listPostOperatorio={
        CodMcdpto: usuarioInfo.Sede,
        CodTipDx: 'O',
        CodEmpCod: usuarioInfo.Empresa,      
        CodMed: codigoMedico,
        CodCir: procir
      }
      postDQListButtonPreoperatorio(listPostOperatorio).then((res)=>{
        setdataPostOperatorio(res.data)
        console.log(res.data)
      })
      setobservacionesPostOperatorio('')
    },[actualizarTable])

    const handleOnclickGuardarPostOperatorio=()=>{
      const guardarPostOperatorio={
        CodTipDx: "O",
        CodDxPrPo: passDataGuardarPostOperatorio.CodDxPrPo,
        CodCir: procir,
        CodMed: codigoMedico,
        CodMcdpto: usuarioInfo.Sede,
        CodEmpCod: usuarioInfo.Empresa,
        CodObsDx: observacionesPostOperatorio
      }
      console.log(guardarPostOperatorio,'guardar')
      if(passDataGuardarPostOperatorio.CodDxPrPo !== ''){
        postInsertPreoperatorio(guardarPostOperatorio).then((res)=>{
          setpassDataGuardarPostOperatorio({
            CodDxPrPo: '',
            DMNomb: ''
          })
          setobservacionesPostOperatorio('')
          setactualizarTable(guardarPostOperatorio)
        })
      }
      
    }

    const handleOnchangeObservaciones=(e)=>{
      setobservacionesPostOperatorio(e.target.value)
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Diagnóstico de descripción Qx
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="px-8 pt-3">
            <h5
              className="text-lg font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              DX POSTOPERATORIO
            </h5>
          </div>
          <div className="flex-auto overflow-y-auto relative p-3">
            <div className="flex py-2 text-left">
              <div className="w-1/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Codigo Diagnóstico
                </label>
                <input
                  disabled={true}
                  defaultValue={passDataGuardarPostOperatorio.CodDxPrPo}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Descripción
                </label>
                <input
                  disabled={true}
                  defaultValue={passDataGuardarPostOperatorio.DMNomb}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Observación
                </label>
                <input
                  type="text"
                  autoComplete='off'
                  value={observacionesPostOperatorio}
                  onChange={handleOnchangeObservaciones}
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-1/5  px-1 ">
                <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                <button
                  type="button"
                  onClick={handleOnclickGuardarPostOperatorio}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className="w-1/5  px-1 ">
                <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                <button
                  onClick={handleOnclickSeleccionDianostico}
                  type="button"
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Lista de Selección Diagnóstico
                </button>
              </div>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-4 inline-block min-w-full sm:px-6 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                          {/* <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >Modificar</th> */}
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Código Dx
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Descripción
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Observación
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          dataPostOperatorio.map((item,index)=>(
                            <TablaDiagnosticoDescripcionQxPostOperatorio item={item} key={index}/>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            {/* <button type="button"
            className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Guardar
          </button> */}
          </div>
        </div>
      </div>
      {modalOnListaDeSeleccionDiagnosticoPostOperatorio? <ModalListaDeSeleccionDeDiagnosticoPostOperatorio setmodalOnListaDeSeleccionDiagnosticoPostOperatorio={setmodalOnListaDeSeleccionDiagnosticoPostOperatorio} passDataPostOperatorio={passDataPostOperatorio}/>:null}
    </div>
  )
}

export default ModalDiagnosticosDescripcionPostOperatorio